export enum EnumOperando {
  M_AVG_M = 46,
  IF = 47,
  SWAP = 48,
  SUMA = 49,
  RESTA = 50,
  PRODUCTO = 51,
  DIVISION = 52,
  DIF = 53,
  MAX = 54,
  MIN = 55,
  MENOR = 56,
  MENOR_IGUAL = 58,
  MAYOR_IGUAL = 59,
  IGUAL = 60,
  DISTINTO = 61,
  M_AVG_D = 62,
  AVG = 63,
  SUMA_BL = 64,
  RESTA_BL = 65,
  ACUMULADO_BL = 66,
  MAYOR = 67
}
